export const APP_FILE_EMAIL_STATISTICS_ROUTE = "/email-statistics";
